import React, { lazy, Suspense, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { List, ListItem, ListItemPrefix, Drawer } from "@material-tailwind/react";
import { Home, Settings, MarkUnreadChatAlt } from "@mui/icons-material";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { useSelector } from "react-redux";
const LogoutModal = lazy(() => import("@/shared/LogoutModal/LogoutModal"));

import "./Sidebar.css"; // Assuming your custom styles for Drawer are defined here
import 'react-toastify/dist/ReactToastify.css';
import TextsmsRoundedIcon from '@mui/icons-material/TextsmsRounded';
import { ToastContainer } from "react-toastify";
import SearchVendorIcon from "@/components/Icons/SearchVendor";
import LoanApplicationIcon from "@/components/Icons/LoanApplicationIcon";



const menuItems = {
  customer: [
    { path: "/customer/dashboard", label: "Home", icon: <Home /> },
    { path: "/customer/inbox", label: "Inbox", icon: <TextsmsRoundedIcon /> },
    { path: "/customer/search-brokers", label: "Find Professionals", icon: <SearchVendorIcon /> },
    { path: "/customer/settings", label: "Settings", icon: <Settings /> },
  ],
  vendor: [
    { path: "/vendor/dashboard", label: "Home", icon: <Home /> },
    { path: "/vendor/inbox", label: "Inbox", icon: <TextsmsRoundedIcon /> },
    { path: "/vendor/loan-applications", label: "Lead Applications", icon: <LoanApplicationIcon /> },
    { path: "/vendor/settings", label: "Settings", icon: <Settings /> },
  ],
};

const Sidebar = ({ open = true, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const role = useSelector((state) => state.auth.auth.role);
  const [logoutOpen, setLogoutOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    setLogoutOpen(false);
    // Your logout logic here
  };

  const sidebarRef = useRef();

  useEffect(() => {
    if (window.innerWidth <= 600 && sidebarRef.current) {
      let touchStartX = 0;
      let touchEndX = 0;

      const handleTouchStart = (e) => {
        touchStartX = e.changedTouches[0].screenX;
      };

      const handleTouchEnd = (e) => {
        touchEndX = e.changedTouches[0].screenX;

        if (touchStartX - touchEndX > 50) {
          onClose && onClose(); // Close sidebar if swiped left
        }
      };

      const sidebarElement = sidebarRef.current;

      sidebarElement.addEventListener("touchstart", handleTouchStart);
      sidebarElement.addEventListener("touchend", handleTouchEnd);

      return () => {
        sidebarElement.removeEventListener("touchstart", handleTouchStart);
        sidebarElement.removeEventListener("touchend", handleTouchEnd);
      };
    }
  }, [onClose]);

  return (
    <>
      <div ref={sidebarRef} className={`custom-sidebar ${open === false ? "closed" : "open"}`}>
        <div className="flex items-center">
          <ToastContainer />
          <List>
            {menuItems[role]?.map((item) => (
              <ListItem
                key={item.path}
                onClick={() => {
                  navigate(item.path);
                  if (onClose) onClose(); // ✅ Close sidebar after navigation
                }}
                className={`menu-item ${isActive(item.path) ? "active" : ""}`}
              >
                <ListItemPrefix>
                  {React.cloneElement(item.icon, {
                    className: `icon ${isActive(item.path) ? "active-icon" : "default-icon"}`,
                  })}
                </ListItemPrefix>
                <span>{item.label}</span>
              </ListItem>
            ))}

            <ListItem
              className="menu-item logout-item mt-4"
              onClick={() => setLogoutOpen(true)}
            >
              <ListItemPrefix>
                <PowerSettingsNewIcon className="icon" />
              </ListItemPrefix>
              Logout
            </ListItem>
          </List>
        </div>
      </div>
      {logoutOpen && (
        <Suspense fallback={<div style={{ textAlign: "center", padding: 20 }}>Loading...</div>}>
          <LogoutModal
            open={logoutOpen}
            onClose={() => setLogoutOpen(false)}
            onLogout={handleLogout}
          />
        </Suspense>
      )}

    </>
  );
};

export default Sidebar;
